<template>
  <span>
<!--    <input type="text" className="form-control" placeholder="" v-model="propsValue">-->

    <p style="">頁面編輯</p>

    <select class="form-control" v-on:change="clickButton2" >
      <option v-for="(button, index) in buttons" v-bind:key="index" :value="button.SystemId">{{ button.Text }}</option>
    </select>


<!--    <span v-for="(button,index) in buttons" :key="index">-->
<!--      <a type="button" class="btn btn-primary btnNav " style="width:200px" @click="btnClick(button)">{{ button.Text }}</a>-->

<!--      <a class="btn btn-primary" @click="edit(button)" style="padding: 1px;margin:1px"><i class="fa fa-pen"></i>  </a>-->
<!--      <a class="btn btn-primary" @click="moveLeft(button)" style="padding: 1px;margin:1px"><i class="fa fa-arrow-left"></i>  </a>-->
<!--      <a class="btn btn-primary" @click="moveRight(button)" style="padding: 1px;margin:1px"><i class="fa fa-arrow-right"></i>  </a>-->
<!--    </span>-->
<!--    <span>-->
<!--      <a class="btn btn-primary" @click="addLast(button)" style="padding: 1px;margin:1px"><i class="fa fa-plus-circle"></i>  </a>-->
<!--    </span>-->

    <DLGButtonEdit ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK"></DLGButtonEdit>


  </span>
</template>

<script>
/**

 **/

import util from "@/pages/common/util";
import arrayUtil from "@/pages/common/arrayUtil";
import DLGButtonEdit from "@/pages/ubossBk/views/components/new/DLGButtonEdit";

export default {
  components: {DLGButtonEdit},
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    buttons: {
      type: Array,
      default() {
        return [
          {
            SystemId:"69ceccd8-008b-4d2a-8ba1-ec0cc2099bd2",
            Text:"首頁",
            OrderKey:"",
          },
          {
            SystemId:"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
            Text:"產品",
            OrderKey:"",
          },
          {
            SystemId:"bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb",
            Text:"關於我們",
            OrderKey:"",
          },
        ]
      }
    },

  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    edit(button){
      this.$refs.dlgEditor.button=button;
      this.$refs.dlgEditor.showModal();
    },
    addLast(){
      let newItem={
        SystemId:"",
        Text:"",
        OrderKey:"",
      };
      newItem.SystemId=util.uuid();

      arrayUtil.orderAppendLast(newItem,this.buttons,"OrderKey")
    },
    moveLeft(item){
      arrayUtil.orderMove(false,item.SystemId,this.buttons,"SystemId","OrderKey")
    },
    moveRight(item){
      arrayUtil.orderMove(true,item.SystemId,this.buttons,"SystemId","OrderKey")
    },
    dlgEditorReturnOK(){

    },
    btnClick(button){
      this.$emit('clickButton', button.SystemId);
    },
    clickButton2(){

      let gotoId="";
      if (this.pageId==="1"){
        gotoId="69ceccd8-008b-4d2a-8ba1-ec0cc2099bd2";
      }else if (this.pageId==="2"){
        gotoId="aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
      }else if (this.pageId==="3"){
        gotoId="bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb";
      }
      this.$router.push({ name: 'OnePageIndex', query: { SystemId: gotoId }})
    }
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>
.btn{
  color:white;
}

</style>
